import React from "react";
import PropTypes from "prop-types";

import ChooseCalendar from "./ChooseCalendar";
import { Button, Typography } from "@mui/material";
import Modal from "../Modal/Modal";

const AddToCalendarModal = ({ open, calendars, onClose }) => {
  return (
    <Modal
      showCloseIcon
      dialogTitle={
        <Typography variant="h5" color="textPrimary">
          Please select Сalendar Application
        </Typography>
      }
      open={open}
      onClose={onClose}
      dialogContent={
        <ChooseCalendar calendarApps={calendars} onClose={onClose} />
      }
      dialogActions={
        <Button
          color="primary"
          onClick={() => {
            onClose();
          }}
        >
          Close
        </Button>
      }
      maxWidth="md"
      scrollable
    />
  );
};

export default AddToCalendarModal;

AddToCalendarModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  calendars: PropTypes.array
};
